<template>
    <div>
        <div class="row justify-content-center">
            <ImagedLink class="col-sm"
                        name="Forums"
                        description="A place to chat"
                        image="assets/forums.png"
                        reference="http://discourse.knockturnmc.com/"
            />
            <ImagedLink class="col-sm remove-small-screen"
                        name="Server IP"
                        description="play.knockturnmc.com"
                        image="assets/server.png"
            />
            <ImagedLink class="col-sm"
                        name="Wiki"
                        description="Lost and trying to find your way?"
                        image="assets/wiki.png"
                        reference="http://docs.knockturnmc.com/"
            />
        </div>
        <div class="row justify-content-center">
            <ImagedLink class="col-sm"
                        name="Donation Store"
                        description="Want to contribute?"
                        image="assets/donation-store.png"
                        reference="http://knockturnmc.buycraft.net/"
            />
            <ImagedLink class="col-sm"
                        name="Discord"
                        description="Voice chats and our community in one place!"
                        image="assets/discord.png"
                        reference="https://discord.gg/r2wdqnh"
            />
            <ImagedLink class="col-sm"
                        name="Git"
                        description="Here's where to go to code!"
                        image="assets/git.png"
                        reference="https://gitea.knockturnmc.com/"
            />
        </div>
    </div>
</template>

<script>
    import ImagedLink from "./ImagedItem";

    /**
     * This entire module is just all the different links
     */
    export default {
        name: "LinkTable",
        components: {ImagedLink}
    }
</script>

<style scoped>

</style>